export const LABELS = ["send_to_ero"] as const;

export type CaseNoteLabel = typeof LABELS[number];

export const CaseNoteLabels = {
  sendToIro: "send_to_ero",
} as const;

export const CASE_NOTE_LABELS = {
  send_to_ero: "Sent to External Reviewer",
} as const;

export interface CaseNoteCreateRequest {
  readonly case_id: number;
  readonly content?: string;
  readonly communication_id?: number;
  readonly labels?: CaseNoteLabel[];
}
